import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'qe-base-error-modal',
	templateUrl: './base-error-modal.component.html',
	styleUrls: ['./base-error-modal.component.scss'],
})
export class BaseErrorModalComponent {
	/**
	 * The heading of the error message
	 */
	@Input() public readonly heading: string = `An error has occurred`;
	/** The subheading of the error message (if applicable) */
	@Input() public readonly subheading?: string;
	/**
	 * The error messages you want to display to the user
	 * Each message will create a new <p> tag with the message inside
	 */
	// eslint-disable-next-line max-len
	@Input() public readonly messages: string[] = [`We're in the dog house. Something went wrong and we're unable to complete your quote. Please try again or Contact Us for help.`];
	/** Whether or not the 'Restart Quote' button should be shown */
	@Input() public readonly showRestartAction: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: {
			heading: string;
			subheading: string;
			messages: string[];
			showRestartAction: boolean;
			restartText?: string;
			showCloseAction: boolean;
		},
		private readonly dialogRef: MatDialogRef<BaseErrorModalComponent>,
	) {
		this.data.messages.length && (this.messages = this.data.messages);
		this.data.showRestartAction ??= false;
		this.data.showCloseAction ??= true;
	}
}
